'use client'

import type { LinkFields } from '@maestro/sanity-cms-blocks/blocks/cms-links/cms-links.types'

import { useCallback, useMemo } from 'react'

import { useHash } from '@pearlconvert/ui/hooks/use-hash'

export const useModalLink = (link?: { url?: string; blank?: boolean }) => {
  const { addOrUpdateHashParam } = useHash()

  const isModalLink = useCallback(
    (link: LinkFields | undefined): link is LinkFields & { url: string } => {
      return Boolean(!link?.blank && link?.url?.startsWith('#modal:'))
    },
    []
  )

  const removeModalPart = useCallback((url: string) => {
    return url.split('#modal:')[1]
  }, [])

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      if (isModalLink(link)) {
        e.preventDefault()
        addOrUpdateHashParam(removeModalPart(link?.url))
      }
    },
    [addOrUpdateHashParam, isModalLink, link, removeModalPart]
  )

  const url = useMemo(() => {
    if (isModalLink(link)) {
      return '#' + removeModalPart(link?.url)
    }
    return link?.url || ''
  }, [isModalLink, link, removeModalPart])

  return {
    url,
    handleClick,
  }
}
